import { Typography } from '@material-ui/core'
import {
  PaginationContainer,
  RowsSelect,
} from './PaginationWithoutButtons.style'
import { usePagination } from './PaginationWithoutButtons.utils'
import { TablePaginationProps } from './PaginationWithoutButtons.types'

const PaginationWithoutButtons = (props: TablePaginationProps) => {
  const { paginationInfoString, options } = usePagination(props)
  const { setPageSize, pageSize, text } = props

  return (
    <PaginationContainer>
      <Typography>{text}</Typography>
      <RowsSelect
        options={options}
        value={[pageSize]}
        handleChange={([value]) => setPageSize(value as number)}
        dropdownPlacement="top"
      />
      <Typography>{paginationInfoString}</Typography>
    </PaginationContainer>
  )
}

export default PaginationWithoutButtons
